import { useState } from 'react'
import { ImageField } from 'components/DropzoneField'
import { getFileNameFromImagekitLink } from 'utils/getFileNameFromImagekitLink'

export const fetchImage = async (link: string): Promise<File | void> => {
  try {
    if (link) {
      const filename = getFileNameFromImagekitLink(link)
      const response = await fetch(link)
      const blob = await response.blob()
      const file = new File([blob], filename)

      return file
    }
  } catch (error) {
    console.error('Error fetching image', link, error)
  }
}

type FetchLink = { imageLink: string; initialLink?: string }

type UseFilesReturn = {
  isLoading: boolean
  avatarFile?: ImageField
  coverFile?: ImageField
  fetchFromLinks: (avatarLink: FetchLink, coverLink: FetchLink) => Promise<void>
}

export const useFiles = (): UseFilesReturn => {
  const [avatarFile, setAvatarFile] = useState<ImageField>()
  const [coverFile, setCoverFile] = useState<ImageField>()
  const [isLoading, setIsLoading] = useState(true)

  const fetchFromLinks = async (avatarLink: FetchLink, coverLink: FetchLink) => {
    try {
      const [avatarFile, coverFile] = await Promise.all([
        fetchImage(avatarLink.imageLink),
        fetchImage(coverLink.imageLink),
      ])

      if (avatarFile) {
        setAvatarFile({
          file: avatarFile,
          src: avatarLink.imageLink,
          isUploaded: true,
          initialValue: avatarLink.initialLink,
        })
      }

      if (coverFile) {
        setCoverFile({
          file: coverFile,
          src: coverLink.imageLink,
          isUploaded: true,
          initialValue: coverLink.initialLink,
        })
      }
    } finally {
      setIsLoading(false)
    }
  }

  return {
    fetchFromLinks,
    coverFile,
    avatarFile,
    isLoading,
  }
}
